import React, {useState, useRef, useMemo} from "react";
import {notification} from "antd";
import { storeMassAddition } from "@/store/massAddition";

import MassAdditionFormCreate from '@/components/mass-addition/MassAdditionFormCreate'
import MassAdditionAccept from '@/components/mass-addition/MassAditionAccept'

import api from '@/api/index'

import { MassAdditionRequest, MassAdditionCreateForm, MassAdditionFormCreateHandle, MassAdditionAcceptHandle } from '@/types/MassAddition'
import { File } from '@/types/Files'

import "../styles/mass-addition.scss";
import {LoadingOutlined} from "@ant-design/icons";
import {getResponseErrorMessage, getApiBusinessError, ApiBusinessError} from "@/utils/api-service";
import { isDisabled } from "@testing-library/user-event/dist/utils";

interface Props {
    serial_id: string | number;
    season_id: string | number;

    updateNav: (key: string) => void;
}

function MassAddition({serial_id, season_id, updateNav}:Props) {
    const [view, setView] = useState<string>("form");
    const [form, setForm] = useState<MassAdditionCreateForm>({
        name: 'Эпизод {number}',
        voiceover: '',
        path: '',
        startNumber: 1,
        voiceoverName: '',
        isActive: true,
        has_internal_ads: false
    })
    const [files, setFiles] = useState<File[]>([])
    const [isSaving, setIsSaving] = useState<boolean>(false)


    const formRef = useRef<MassAdditionFormCreateHandle>(null);
    const acceptRef = useRef<MassAdditionAcceptHandle>(null)

    const onCancel = () => {
        toggleView(false)
    };

    const handleNext = () => {
        if(isSaving) {
            return false;
        }

        toggleView()
    };

    const getFilesForSave = () => {
        const acceptValues = acceptRef.current.getValue();

        if(!Array.isArray(acceptValues.files)) {
            return []
        }

        const listFiltered = acceptValues.files.filter((item) => {
            // Уже добавленный файл выбрать нельзя (чекбокс заблокирован), но
            // фильтруем и здесь: состояние UI могло рассинхронизироваться,
            // а бэкенд такой файл всё равно отклонит
            return Boolean(item.isChecked && !item.is_added);
        })

        return listFiltered.map((item, index) => {
            return {
                video_file: item.relative_path,
                sort_order: item.orderBy
            }
        })
    }

    const save = async() => {
        try {
            if(!season_id) {
                return
            }

            const filesForSave = getFilesForSave()

            if(filesForSave.length === 0) {
                notification.warning({
                    message: 'Нужно что бы был хотя бы один файл'
                });
                acceptRef.current.showLoader('stop');
                return
            }

            storeMassAddition.startLoad(filesForSave.length)

            console.log('filesForSave', filesForSave)

            for(const file of filesForSave) {
                const data:MassAdditionRequest = {
                    film_name: form.name || '',
                    voiceover_id: form.voiceover || 0,
                    isActive: form.isActive ?? true,
                    has_internal_ads: form.has_internal_ads || false,
                    files: [file]
                }

                const response = await api.massAdition.save(serial_id, season_id, data)

                // Бэкенд отдаёт бизнес-отказ с HTTP 200 ({success:false}) — не проглатываем
                const businessError = getApiBusinessError(response)
                if (businessError) {
                    throw new ApiBusinessError(businessError)
                }

                storeMassAddition.loadFile()
            }

            notification.success({
                message: 'Успешно'
            });

            setTimeout(() => {
                setView('form')
                setForm({
                    name: 'Эпизод {number}',
                    voiceover: '',
                    path: '',
                    startNumber: 1,
                    voiceoverName: '',
                    isActive: true,
                    has_internal_ads: false
                })
                updateNav('list-series')
                storeMassAddition.clear()
            }, 3000)

        } catch(err) {
            console.error(err)
            acceptRef.current.showLoader('stop')
            const messageFormatter = getResponseErrorMessage(err, 'Ошибка при сохранении')
            notification.error({
                message: messageFormatter
            });

        } finally {
            setIsSaving(false)
        }
    }

    const toggleView = (isNext:boolean = true) => {
        switch(view) {
            case 'form':
                if(isNext) {
                    getFiles()
                } else {
                    setView('form')
                }
                break;

            case 'accept':
                if(isNext) {
                    if(isSaving) {
                        return;
                    }

                    setIsSaving(true)
                    acceptRef.current.showLoader('control')
                    setTimeout(() => {
                        save()
                    }, 3000)
                } else {
                    setView('form')
                }
                break;
        }
    }

    const isValidFormCreate = (data:MassAdditionCreateForm):boolean => {
        if(!data.name || !data.voiceover || !data.path || (data.startNumber < 0)) {
            return false
        }

        return true
    }

    const getFiles = async() => {
        try {
            const formData = formRef.current.getValue();
            setForm(formData)

            if(!isValidFormCreate(formData)) {
                notification.warning({
                    message: 'Заполните все поля'
                });
                return
            }

            try {
                const responseFiles = await api.files.get(formData.path)
                let listFiles = responseFiles.data.data.files

                setFiles(listFiles || [])
                setView('accept')
            } catch (error) {
                console.error(error);
                const messageFormatter = getResponseErrorMessage(
                    error,
                    "Ошибка при редактировании сериала"
                );
                notification.error({
                    message: messageFormatter
                });
            }

        } catch(err) {
            console.error(err)
            setFiles([])
        }
    }

    const disabledNext = useMemo(() => {
        console.log('memo', isSaving)

        return isSaving
    }, [isSaving])

    return (
        <div className="mass-addition">

            <div className="app-container">
                <div className="app-content">
                    {
                        view === 'form' && <MassAdditionFormCreate ref={formRef} formDefault={form} />
                    }

                    {
                        view === 'accept' && <MassAdditionAccept files={files} form={form} ref={acceptRef} />
                    }

                    <div className="app-footer-control">
                        <button className="app-btn secondary" onClick={onCancel}>
                            Отмена
                        </button>
                        <button
                            className="app-btn"
                            onClick={handleNext}
                            disabled={disabledNext}
                        >
                            Далее
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MassAddition;
